import { Component } from '@theme/component';
class RelatedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.abort) return;
    this.abort = new AbortController();
    this.track = this.querySelector('.wb-related-track');
    this.nextPage = 2;
    this.hasMore = Number(this.dataset.count) > 50;
    this.addEventListener('click', event => {
      if(event.target.closest('[data-related-retry]')) { this.loadMore(); return; }
      const button = event.target.closest('[data-related-step]');
      if (!button) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const cardWidth = this.track.firstElementChild?.getBoundingClientRect().width || 0;
      const distance = matchMedia('(min-width:750px)').matches ? 4 * (cardWidth + parseFloat(getComputedStyle(this.track).columnGap)) : this.track.clientWidth;
      this.track.scrollBy({left: Number(button.dataset.relatedStep) * distance * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, {signal:this.abort.signal});
    this.track.addEventListener('scroll', () => this.sync(), {passive:true,signal:this.abort.signal});
    this.resize = new ResizeObserver(() => this.sync());
    this.resize.observe(this.track);
    this.sync();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.abort?.abort(); this.abort=null; this.resize?.disconnect(); }
  sync() {
    const image = this.track.querySelector('.wb-product-image');
    if(image){
      const rect=image.getBoundingClientRect();
      this.style.setProperty('--wb-related-arrow-top',`${rect.top-this.getBoundingClientRect().top+rect.height/2}px`);
    }
    const position = Math.abs(this.track.scrollLeft), max = this.track.scrollWidth - this.track.clientWidth;
    this.querySelector('[data-related-step="-1"]').disabled = position < 2;
    this.querySelector('[data-related-step="1"]').disabled = max - position < 2 && !this.hasMore;
    if (this.hasMore && max - position < this.track.clientWidth * 1.5 && !this.failed) this.loadMore();
  }
  async loadMore() {
    if(this.loading || !this.hasMore) return;
    this.loading=true; this.failed=false;
    const error=this.querySelector('.wb-related-error'); error.hidden=true;
    try {
      const url = new URL(this.dataset.collectionUrl, location.origin);
      url.searchParams.set('section_id','wb-related-feed');
      url.searchParams.set('page',String(this.nextPage));
      const response=await fetch(url,{signal:this.abort.signal});
      if(!response.ok) throw new Error('Category unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const feed=doc.querySelector('[data-related-feed]');
      if(!feed) throw new Error('Category unavailable');
      const ids=new Set([...this.track.children].map(card=>card.dataset.relatedId));
      ids.add(this.dataset.productId);
      for(const card of feed.children) { if(!ids.has(card.dataset.relatedId)) { ids.add(card.dataset.relatedId); this.track.append(document.importNode(card,true)); } }
      this.hasMore=Boolean(feed.dataset.next); this.nextPage=Number(feed.dataset.next)||this.nextPage+1;
    } catch(e) { if(e.name!=='AbortError') { this.failed=true; error.hidden=false; } }
    finally { this.loading=false; if(this.isConnected) this.sync(); }
  }
}
if(!customElements.get('wb-related-products')) customElements.define('wb-related-products',RelatedProducts);
